import { ReactNode, useContext } from "react";
import AuthProvider from "../../context/auth";
import SignIn from "../../pages/auth/SignIn";
import Loader from "../../assets/components/loader/Loader";

const Providers = ({ children }: { children: ReactNode }) => {
  const { user, authLoading } = useContext(AuthProvider);

  // Bij een refresh weet Firebase pas ná initialisatie of er een sessie is;
  // zonder deze gate flitst het inlogscherm even voor ingelogde gebruikers.
  if (authLoading) return <Loader pageTitle="Applicatie laden" />;

  return <> {user ? children : <SignIn />} </>;
};

export default Providers;
